import React, { useState, useRef } from 'react';
import RoadmapSection from '../RoadmapSection/RoadmapSection';
import './SchoolStudent.css';

const PROGRAMS = [
  {
    tag: 'ONLINE · GRADE 6–9 · AGE 11–14',
    badge: 'Kits to Home',
    badgeStyle: 'white',
    title: 'Innovators Programme',
    subtitle: '"From Curiosity to Creator"',
    tags: ['12 months', '96 live sessions', '3 Certificates', 'Kits couriered'],
    points: [
      'A 12-month hands-on STEM journey with live interactive sessions and real hardware kits delivered to their homes',
      'The course is divided into 3 Progressive phases — Circuits & Electronics, IoT & Smart Systems, and Robotics & Drones',
      'Helps students build practical skills through project-based learning',
    ],
    modeBtns: ['Hybrid', 'Offline'],
    cta: '🗺 View 12-Month Roadmap →',
    ctaStyle: 'cta--dark',
    customizable: false,
    isRoadmap: true,
  },
  {
    tag: 'REGULAR PROGRAMME',
    badge: 'Weekend Batches',
    badgeStyle: 'outline',
    title: 'Hands on Training Program',
    trainingType: 'regular',
    tags: ['6 months', '48 hrs', '2 hrs/week', 'Weekends'],
    points: [
      'A practical weekend training programme designed for school students',
      'Covers Electronics, IoT, Robotics, and various emerging technology courses through interactive hands-on sessions',
      'Students learn by building real projects',
      'Develops creativity, problem-solving, and technical skills in a school-friendly schedule',
    ],
    modeBtns: ['Offline', 'Hybrid (+kit)'],
    customizable: true,
    cta: ' More Details',
    ctaStyle: 'cta--dark',
    isRoadmap: false,
  },
  {
    tag: 'INTENSIVE PROGRAMME',
    badge: 'Holiday Intensive',
    badgeStyle: 'outline',
    title: 'Daily Session Training',
    trainingType: 'intensive',
    tags: ['15 days', '30 hours', '2 hrs/Session', 'Holiday batch'],
    points: [
      'A short-term intensive program designed for holidays',
      'Daily structured sessions with hands-on activities and guided practice',
      'Helps in quick learning of core technical skills',
      'Focused, practical training in an immersive learning format',
    ],
    modeBtns: ['Offline', 'Hybrid (+kit)'],
    customizable: true,
    cta: 'More Details',
    ctaStyle: 'cta--dark',
    isRoadmap: false,
  },
  {
    tag: 'SEASONAL CAMP',
    badge: 'Summer/Winter Camp',
    badgeStyle: 'outline',
    title: 'Hands on Training Camp',
    trainingType: 'camp',
    tags: ['5-7 days', '21 hrs', '3 hrs/session', 'Project focus'],
    points: [
      'A 5-7 days interactive learning camp to explore Electronics, IoT, and Robotics',
      'Engaging, project-based activities with a hands-on learning focus',
      'Students build mini-projects while understanding how technology works in real-world applications',
      'Ideal for curious minds to learn, experiment, and create in a fun and practical environment',
    ],
    modeBtns: ['Offline', 'Hybrid (+kit)'],
    customizable: true,
    cta: 'More Details',
    ctaStyle: 'cta--dark',
    isRoadmap: false,
  },
];

function SchoolStudent({ onClose, onMoreDetails, onOpenRoadmap }) {
  const [showRoadmap, setShowRoadmap] = useState(false);
  const roadmapRef = useRef(null);

  const handleRoadmap = () => {
    onOpenRoadmap();
    setShowRoadmap(true);
    setTimeout(() => {
      roadmapRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <div className="ss__overlay">
      <div className="ss__box">

        <button className="ss__close" onClick={onClose}>✕</button>

        <h2 className="ss__title">School Student Training</h2>
        <p className="ss__subtitle">
          Walk-in at any ibots centre. Choose Hybrid to get a DIY kit sent home,
          or attend fully in-person with Offline mode.
        </p>

        <div className="ss__badges">
          {[
            { text: 'Ratio: 5:1' },
            { text: 'Mode: Hybrid / Offline' },
            { text: 'Certificates Provided' },
            { text: 'Kits at Centre (not for takeaway)' },
          ].map((b, i) => (
            <span key={i} className="ss__badge">
              <span>{b.icon}</span> {b.text}
            </span>
          ))}
        </div>

        <div className="ss__policy">
          <span className="ss__policy-icon">🔧</span>
          <div>
            <strong>KIT POLICY — PLEASE NOTE</strong>
            <p>
              All kits used during training sessions are available for use at the
              ibots centre and <strong>must be returned at the end of each session</strong>.
              If you wish to take a kit home for further practice,{' '}
              <strong>additional kit charges apply</strong> based on the tools and
              components included in that specific kit.{' '}
              <a href="#" className="ss__policy-link">
                View all DIY Kits on ibots.in →
              </a>
            </p>
          </div>
        </div>

        <div className="ss__cards">
          {PROGRAMS.map((p, i) => (
            <div key={i} className="ss__card">

              <div className="ss__card-header">
                <span className="ss__card-tag">{p.tag}</span>
                <span className={`ss__card-badge ss__card-badge--${p.badgeStyle}`}>
                  {p.badge}
                </span>
              </div>

              <div className="ss__card-body">
                <h3 className="ss__card-title">{p.title}</h3>
                {p.subtitle && (
                  <p className="ss__card-subtitle">{p.subtitle}</p>
                )}

                <div className="ss__card-tags">
                  {p.tags.map((t, j) => (
                    <span key={j} className="ss__tag">{t}</span>
                  ))}
                </div>

                <ul className="ss__card-points">
                  {p.points.map((pt, j) => (
                    <li key={j}>{pt}</li>
                  ))}
                </ul>

                <div className="ss__mode-btns">
                  {p.modeBtns.map((mb, j) => (
                    <button key={j} className="ss__mode-btn">{mb}</button>
                  ))}
                </div>

                {p.customizable && (
                  <p className="ss__customize">
                    ✏️ <strong>Programme content can be tailored to your
                    learning goals — customisation available at applicable
                    charges.</strong>
                  </p>
                )}

                <button
                  className="cs__card-btn"
                  onClick={() => {
                    if (p.isRoadmap) {
                      handleRoadmap();
                    } else {
                      setShowRoadmap(false);
                      onMoreDetails(p.trainingType);
                    }
                  }}
                >
                  More Details
                </button>
              </div>
            </div>
          ))}
        </div>

      </div>

      <div ref={roadmapRef}>
        {showRoadmap && (
          <RoadmapSection onClose={() => setShowRoadmap(false)} />
        )}
      </div>

    </div>
  );
}

export default SchoolStudent;
